/*
 * Copyright (C) 2017-2019 Dremio Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { setDefaultFontLoading } from "@ui5/webcomponents-base/dist/config/Fonts.js";

// The legacy Checkbox pulls UI5 into this entry. As in components/ui5Theme.ts,
// the apps bundle SAP 72 themselves and UI5's own font faces point at a CDN
// the CSP blocks. This must run before UI5 boots, which waits for DOM ready.
setDefaultFontLoading(false);
